import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6aadf5a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ©2019-2022北京市维泰律师事务所版权所有｜侵权必究｜")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "京ICP备2022020662号", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "footer"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "©2019-2022北京市维泰律师事务所版权所有｜侵权必究", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    target: "_blank"
  }, "京ICP备2022020662号")
], -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.mobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
}